function fieldChangeListener(defValApplicator, fieldChangeRuleExecutor, qRules) {
    const checkqRulesCommand = async (dsNode) => {
        const nodeName = dsNode.localName();
        const dataSource = dsNode.getDsName();

        if (dataSource === 'QdabraRules' && nodeName === 'Command') {
            const commandParams = {
                node: dsNode
            };

            await qRules.executeCommandAsync(commandParams);
        }
    };

    async function notifyChangeAsync(dsNode) {
        const result = await fieldChangeRuleExecutor.runFieldChangeRulesAsync(dsNode);

        // [2021-03-31] - Removed use of ruleSetResultToAssignmentResult, which 
        //                seemingly wasn't doing anything useful
        if (!(result && result.shouldStop)) {
            await defValApplicator.processAffectedDefaultValuesAsync(dsNode);
        }

        await checkqRulesCommand(dsNode);
    }

    return {
        notifyChangeAsync,
    };
}

export default fieldChangeListener;